export const SIGNATURE_CURATED_HERO_FALLBACK = {
  src: "https://images.unsplash.com/photo-1766603636774-5f328e0da870?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcmNoaXRlY3R1cmFsJTIwaG9tZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3NjUwNjI1NXww&ixlib=rb-4.1.0&q=85",
  alt: "Curated luxury editorial fallback exterior",
};